//REDUCER
import { RECIEVE_USER_COMPLETIONS } from '../actions'


import { createAction, createReducer } from '@reduxjs/toolkit'

const initialCompletionsState = {
  enrolledCourses: [],
  completedCourses: [],
  completedLessons: {},
  //completedLessonsHistory: {},
  enrolledLessons: []
};


const completions = createReducer(initialCompletionsState, (builder) => {
    builder
      .addCase(createAction(RECIEVE_USER_COMPLETIONS), (state, action) => {
        state.enrolledCourses = action.userCompletions.enrolledCourses;
        state.completedCourses = action.userCompletions.completedCourses;
        state.completedLessons = action.userCompletions.completedLessons;
        //state.completedLessonsHistory = action.userCompletions.completedLessonsHistory;
        state.enrolledLessons = action.userCompletions.enrolledLessons;
      
      })
  })


export default completions